module.exports = __webpack_public_path__ + "static/media/kwh-01-yellow.8fc44ad8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Icons/kwh-01-yellow.png
// module id = 7690
// module chunks = 0